
import React from "react";
import {useEffect, useState} from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';

import axios from "axios";
import useApi from 'hooks/useApi';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 20,
    },
    paper: {
        marginTop: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(3),
    },
    spinner: {
        marginTop: 50,
    }
}));

const getCurrentDate = () => {
    const tmp = new Date();
    return new Date(tmp.getTime() - tmp.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}


const GEO_ENABLED = process.env.NODE_ENV === 'production';

const StopRide = (props) => {

    const classes = useStyles();
    const [{data, isLoading}, ] = useApi.get("/api/rides/last");
    const [{isWorking}, stopRide] = useApi.post('/api/rides/stop');
    const [stateTo, setStateTo] = useState("locating...");


    const validate = (values) => {
        const errors = {};
        if (!values.to) {
            errors.to = "Required";
        }

        if (!values.endTime) {
            errors.endTime = "Required";
        }

        if (!values.odoEnd) {
            errors.odoEnd = "Must be greater than 0";
        }
        return errors;
    };

    const onSubmit = async (values, { setSubmitting }) => {
        setSubmitting(false);
        await stopRide({
            id: data.Data.ID,
            to: values.to,
            endtime: values.endTime,
            odoend: values.odoEnd,
            fuelprice: values.fuelPrice,
            fuellitres: values.fuelLitres,
            type: values.type,
        });
        props.history.push('/');
    };

    const onCancel = () => {
        props.history.push('/');
    };

    // Get current location street and city based on GPS:
    useEffect(() => {
        if (navigator.geolocation && GEO_ENABLED) {
            navigator.geolocation.getCurrentPosition((async (position) => {
                const lon = position.coords.longitude;
                const lat = position.coords.latitude;
                try {
                    const data = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1`);
                    console.log(data);
                    if (data.data) {
                        const to = data.data.address.road + ", " + data.data.address.city;
                        setStateTo(to);
                    }
                }catch (error) {
                    alert(error);
                }
            }));
        }else {
            setStateTo("");
        }
    }, [])


    const initialValues = {
        to: stateTo,
        endTime: getCurrentDate(),
        odoEnd: "",
        fuelLitres: 0,
        fuelPrice: 0.0,
        type: "Private",
    };


    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                {isLoading && <Typography variant="h5"> Loading... </Typography> }
                {isWorking && <Typography variant="h5"> Saving... </Typography> }
                {(isLoading || isWorking) && ( <CircularProgress className={classes.spinner} /> )}

                {!isLoading && !isWorking && (
                    <>
                        <Typography component="h1" variant="h5">
                            Stop Ride
                        </Typography>

                        <Formik
                            enableReinitialize={true}
                            initialValues={initialValues}
                            validate={validate}
                            onSubmit={onSubmit}
                        >
                            <Form className={classes.form}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            name="to"
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            label="To"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            as={TextField}
                                        />
                                        <ErrorMessage name="to" />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            name="endTime"
                                            type="datetime-local"
                                            fullWidth
                                            variant="outlined"
                                            label="End Time"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            as={TextField}
                                        />
                                        <ErrorMessage name="endTime" />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            name="odoEnd"
                                            type="number"
                                            fullWidth
                                            label="Odo End"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                pattern: "[0-9]*",
                                                inputMode: "numeric",
                                            }}
                                            as={TextField}
                                        />
                                        <ErrorMessage name="odoEnd" />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            name="type"
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            label="Type"
                                            InputLabelProps={{ shrink: true }}
                                            as={TextField}
                                        />
                                        <ErrorMessage name="type" />
                                    </Grid>


                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            name="fuelLitres"
                                            type="number"
                                            fullWidth
                                            label="Fuel (litres)"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                pattern:"[0-9]*",
                                                inputMode:"numeric"
                                            }}
                                            as={TextField}
                                        />
                                        <ErrorMessage name="fuelLitres" />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            name="fuelPrice"
                                            type="number"
                                            fullWidth
                                            label="Fuel (price)"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                pattern:"[0-9.]*",
                                                inputMode:"numeric"
                                            }}
                                            as={TextField}
                                        />
                                        <ErrorMessage name="fuelPrice" />
                                    </Grid>


                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                        >
                                            Stop
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            type="button"
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={onCancel}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Form>
                        </Formik>
                    </>
                )}
            </div>
        </Container>
    );
};

export default StopRide;
